import { render, staticRenderFns } from "./ReadyToBoard.vue?vue&type=template&id=7245c585&"
import script from "./ReadyToBoard.vue?vue&type=script&lang=js&"
export * from "./ReadyToBoard.vue?vue&type=script&lang=js&"
import style0 from "./ReadyToBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports